import { TextField, InputAdornment } from "@mui/material";

const YenTextField = (props: any) => {
    const { v, manageChange, isError, errorMessage, isReadOnly } = props;
    return(
        <TextField
        InputProps={{
            endAdornment: (
                <InputAdornment position="start">
                    ¥
                </InputAdornment>
            )
        }}
        variant='standard' value={v}
        type='number'
        onChange={(e:any) => manageChange(parseInt(e.target.value))}
        error={isError && !isReadOnly}
        disabled={isReadOnly}
        helperText={isError ? errorMessage : ''}
        />
    )
}

export default YenTextField;